import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SnackBarService } from '@app/services/snack-bar.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { ContractTypeService } from '@services/contract-type.service';
import { Breadcrumb } from '@app/models/view-models/breadcrumb';
@Component({
  selector: 'app-contract-types-index',
  templateUrl: './contract-types-index.component.html',
  styleUrls: ['./contract-types-index.component.scss']
})
export class ContractTypesIndexComponent extends BaseComponent implements OnInit {
  public dataSource: any;
  public data: any;
  public displayedColumns = ['name', 'user_count', 'actions'];
  public dataLoaded = false;
  public node: Breadcrumb;
  constructor(
    public contractTypeService: ContractTypeService,
    public router: Router,
    public state: State,
    public snackbarService: SnackBarService,
    public dialog: MatDialog
  ) {
    super();
    this.setObjects({
      modelService: contractTypeService,
      router,
      state,
      snackbarService,
      dialog
    });
    this.setPageVars({
      listenForIndexUpdate: true
    });
    this.modelServiceGetAll().then(() => (this.dataLoaded = true));
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.node = {
      label: 'Contract Types',
      link: 'contract-types',
      title: 'Contract Types'
    };
    this.buildSettingsBreadcrumb(this.node);
  }
}
